import React from 'react';
import PropTypes from 'prop-types';

/**
 * ModalCard - A wrapper that renders a standard HTML div with Bulma class names
 * 
 * This component accepts the same props as Bloomer ModalCard for easy migration
 */
const ModalCard = ({
  className = '',
  children = null,
  style = {},
  tag: Tag = 'div',
  pose = null,
  ...props
}) => {
  // Build the class names based on props
  const getClassNames = () => {
    const classes = ['modal-card'];
    
    // Add custom class names
    if (className) {
      classes.push(className);
    }
    
    return classes.join(' ');
  };

  return (
    <Tag
      className={getClassNames()}
      style={style}
      pose={pose}
      {...props}
    >
      {children}
    </Tag>
  );
};

// eslint-disable-next-line react/require-default-props
ModalCard.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
  tag: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.object
  ]),
  pose: PropTypes.string,
};



export default ModalCard;
